export enum Roles {
  start = 'Start',
  finish = 'Finish',
  fence = 'Fence',
  public = 'Public',
  manager = 'Manager',
  secretariat = 'Secretariat',
}
